// extracted by mini-css-extract-plugin
export default {"root":"Input_root__EqAiF"};